import { useState, useEffect } from "react";
import spektorLogo from "./spektor-logo-w.png";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { register, reset } from "./features/auth/authSlice";
import toast from "./shared/toast";

const Register = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    password2: "",
  });

  const { email, password, password2 } = formData;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user, isLoading, isSuccess, message, isError } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    if (isError) {
      toast("error", message);
    }

    if (isSuccess || user) {
      navigate("/login");
    }

    dispatch(reset());
  }, [isError, isSuccess, user, message, navigate, dispatch]);

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (password !== password2) {
      toast("error", "A beírt két jelszó nem egyezik");
    } else {
      const userData = {
        email,
        password,
      };

      dispatch(register(userData));
    }
  };

  return (
    <div className="container-fluid p-0">
      <div className="row m-0">
        <div className="col-12 p-0">
          <div className="login-card login-dark">
            <div>
              <div>
                <a className="logo" href="index.html">
                  <img
                    className="img-fluid for-light m-auto"
                    src={spektorLogo}
                    alt="looginpage"
                  />
                  <img
                    className="img-fluid for-dark"
                    src={spektorLogo}
                    alt="logo"
                  />
                </a>
              </div>
              <div className="login-main">
                <form className="theme-form" onSubmit={onSubmit}>
                  <h2 className="text-center">Regisztráció {user}</h2>

                  <div className="form-group">
                    <label className="col-form-label">E-mail cím</label>
                    <input
                      id="email"
                      name="email"
                      className="form-control"
                      type="email"
                      placeholder=""
                      value={email}
                      onChange={onChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label className="col-form-label">Jelszó</label>
                    <div className="form-input position-relative">
                      <input
                        id="password"
                        className="form-control"
                        type="password"
                        name="password"
                        placeholder=""
                        value={password}
                        onChange={onChange}
                        required
                      />
                      <div className="show-hide">
                        <span className="show"> </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-form-label">Jelszó újra</label>
                    <div className="form-input position-relative">
                      <input
                        id="password2"
                        className="form-control"
                        type="password"
                        name="password2"
                        placeholder=""
                        value={password2}
                        onChange={onChange}
                        required
                      />
                      <div className="show-hide">
                        <span className="show"> </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group mb-0 checkbox-checked">
                    <div className="text-end mt-3">
                      <button
                        className="btn btn-primary btn-block w-100"
                        type="submit"
                      >
                        Regisztráció
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
